import {createAsyncThunk} from '@reduxjs/toolkit';

import {AIS3_SLICE} from '../ais-slice-constants';
import {TFetchAisDashboardDataParams, TFetchAisDashboardDataResponseDto, fetchAisDashboardData} from './ais-dashboards-api';
import {EAisDashboardCode} from './ais-dashboards-constants';

type TGetAisS4S5DashboardDataArgs = Omit<TFetchAisDashboardDataParams, 'code'> & {
    code: EAisDashboardCode.REQUEST_STATISTIC_S4_S5;
}
export const getAisS4S5DashboardData = createAsyncThunk<TFetchAisDashboardDataResponseDto, TGetAisS4S5DashboardDataArgs>(
    `${AIS3_SLICE}/getAisS4S5DashboardData`,
    async (arg, {rejectWithValue}) => {
        try {
            const response = await fetchAisDashboardData(arg ?? undefined);
            const {data} = response;
            return data;
        } catch (e) {
            return rejectWithValue(e);
        }
    },
);

type TGetAisSystemUnavailabilityDashboardDataArgs = Omit<TFetchAisDashboardDataParams, 'code'> & {
    code: EAisDashboardCode.SYSTEM_UNAVAILABILITY;
}
export const getAisSystemUnavailabilityDashboardData = createAsyncThunk<
TFetchAisDashboardDataResponseDto, TGetAisSystemUnavailabilityDashboardDataArgs>(
    `${AIS3_SLICE}/getAisSystemUnavailabilityDashboardData`,
    async (arg, {rejectWithValue}) => {
        try {
            const response = await fetchAisDashboardData(arg ?? undefined);
            const {data} = response;
            return data;
        } catch (e) {
            return rejectWithValue(e);
        }
    },
);

type TGetAisTokenStatusDashboardDataArgs = Omit<TFetchAisDashboardDataParams, 'code'> & {
    code: EAisDashboardCode.TOKEN_STATISTIC;
}
export const getAisTokenStatusDashboardData = createAsyncThunk<
    TFetchAisDashboardDataResponseDto,
    TGetAisTokenStatusDashboardDataArgs
>(
    `${AIS3_SLICE}/getAisTokenStatusDashboardData`,
    async (arg, {rejectWithValue}) => {
        try {
            const response = await fetchAisDashboardData(arg ?? undefined);
            const {data} = response;
            return data;
        } catch (e) {
            return rejectWithValue(e);
        }
    },
);

type TGetAisSystemAvailabilityStatusDashboardDataArgs = Omit<TFetchAisDashboardDataParams, 'code'> & {
    code: EAisDashboardCode.SYSTEM_AVAILABILITY_STATUS;
}
export const getAisSystemAvailabilityStatusDashboardData = createAsyncThunk<
    TFetchAisDashboardDataResponseDto,
    TGetAisSystemAvailabilityStatusDashboardDataArgs
>(
    `${AIS3_SLICE}/getAisSystemAvailabilityStatusDashboardData`,
    async (arg, {rejectWithValue}) => {
        try {
            const response = await fetchAisDashboardData(arg ?? undefined);
            const {data} = response;
            return data;
        } catch (e) {
            return rejectWithValue(e);
        }
    },
);

type TGetAisSummaryTransactionsProtocolDashboardDataArgs = Omit<TFetchAisDashboardDataParams, 'code'> & {
    code: EAisDashboardCode.SUMMARY_TRANSACTIONS_PROTOCOL_STATISTIC;
}
export const getAisSummaryTransactionsProtocolDashboardData = createAsyncThunk<
TFetchAisDashboardDataResponseDto, TGetAisSummaryTransactionsProtocolDashboardDataArgs >(
    `${AIS3_SLICE}/getAisSummaryTransactionsProtocolDashboardData`,
    async (arg, {rejectWithValue}) => {
        try {
            const response = await fetchAisDashboardData(arg ?? undefined);
            const {data} = response;
            return data;
        } catch (e) {
            return rejectWithValue(e);
        }
    },
);

type TGetAisRequestStatisticS3S6S12Args = Omit<TFetchAisDashboardDataParams, 'code'> & {
    code: EAisDashboardCode.REQUEST_STATISTIC_S3_S6_S12;
}
export const getAisRequestStatisticS3S6S12 = createAsyncThunk<
    TFetchAisDashboardDataResponseDto,
    TGetAisRequestStatisticS3S6S12Args
>(
    `${AIS3_SLICE}/getAisRequestStatisticS3S6S12`,
    async (arg, {rejectWithValue}) => {
        try {
            const response = await fetchAisDashboardData(arg ?? undefined);
            const {data} = response;
            return data;
        } catch (e) {
            return rejectWithValue(e);
        }
    },
);

type TGetAisRegisterDocumentsArgs = Omit<TFetchAisDashboardDataParams, 'code'> & {
    code: EAisDashboardCode.DOC_JOURNAL;
}
export const getAisRegisterDocuments = createAsyncThunk<TFetchAisDashboardDataResponseDto, TGetAisRegisterDocumentsArgs>(
    `${AIS3_SLICE}/getAisRegisterDocuments`,
    async (arg, {rejectWithValue}) => {
        try {
            const response = await fetchAisDashboardData(arg ?? undefined);
            const {data} = response;
            return data;
        } catch (e) {
            return rejectWithValue(e);
        }
    },
);
